import { ScenarioType, ScenarioTypeTitle } from '../types/scenario-modeling.types';
import { getTranslation } from './get-translation.util';

export const generateScenarioDefaultName = (type: ScenarioType, count: number): string => {
  return `${getTranslation(ScenarioTypeTitle[type])} - ${count + 1}`;
};
